<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style lang="scss">
  /* 引入样式 */
  @import "styles/index";

  #app {
    width: 100%;
    height: 100%;
  }
</style>
